import React, { useEffect, useState } from 'react';
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import RevertButton from '../RevertButton';
import AddButton from '../AddButton';
import NestedAccessoriesModal from '../NestedAccessoriesModal';
import addAccessory from '../addAccessory';
import getIntoNested from '../getIntoNested';
import useStyles from './styles';
import { inputDataCustom, treeStructureSettingsCustom } from '../../../../../utils/custom_prop_types/customPropTypes';

export default function GenericAccessories({
  inputData,
  setInputDataToSend,
  fetchProductsBySection,
  setOpenModal,
  addedProducts,
  treeStructureSettings,
  setTreeStructureSettings,
  accessoryList,
  isCorner,
}) {
  const [accessoriesVisibility, setAccessoriesVisibility] = useState('flex');
  const [scrollVisibility, setScrollVisibility] = useState('hidden');
  const classes = useStyles();

  useEffect(() => {
    if (accessoryList?.['hydra:member']?.length > 0) {
      setAccessoriesVisibility('none');
      setScrollVisibility('scroll');
    }
  }, [accessoryList]);

  return (
    <>
      <Paper
        className={classes.accessoryTable}
        style={{ overflowY: scrollVisibility }}
      >
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableBody>
              {!isCorner && (
                <TableRow>
                  <TableCell
                    className={classes.accessoryNotification}
                    style={{ display: accessoriesVisibility }}
                  >
                    Choose panels and posts
                  </TableCell>
                </TableRow>
              )}
              {accessoryList?.['hydra:member']?.map((nestedProduct) => (
                <TableRow key={nestedProduct['@id']}>
                  <TableCell
                    onClick={() => getIntoNested({
                      nestedProduct,
                      addedProducts,
                      inputData,
                      fetchProductsBySection,
                      treeStructureSettings,
                      setTreeStructureSettings,
                      setOpenModal,
                    })}
                    className={classes.nestedProduct}
                  >
                    {nestedProduct.description}
                  </TableCell>
                  <TableCell
                    className={classes.buttonGroup}
                  >
                    {addedProducts.includes(nestedProduct['@id'] + nestedProduct.association)
                    && (
                      <RevertButton
                        nestedProduct={nestedProduct}
                      />
                    )}
                    <AddButton
                      nestedProduct={nestedProduct}
                      handleAddAccessory={(event) => addAccessory({
                        currentTarget: event.currentTarget,
                        inputData,
                        setInputDataToSend,
                        treeStructureSettings,
                        setTreeStructureSettings,
                      })}
                      isRootNode
                    />
                  </TableCell>
                </TableRow>
              ))}
              <NestedAccessoriesModal
                handleAddAccessory={(event) => addAccessory({
                  currentTarget: event.currentTarget,
                  inputData,
                  setInputDataToSend,
                  treeStructureSettings,
                  setTreeStructureSettings,
                })}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}

GenericAccessories.defaultProps = {
  isCorner: false,
};

GenericAccessories.propTypes = {
  accessoryList: PropTypes.objectOf(PropTypes.any).isRequired,
  inputData: inputDataCustom.isRequired,
  addedProducts: PropTypes.arrayOf(PropTypes.any).isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
  fetchProductsBySection: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  treeStructureSettings: treeStructureSettingsCustom.isRequired,
  setTreeStructureSettings: PropTypes.func.isRequired,
  isCorner: PropTypes.bool,
};
